import React from 'react';
import { css } from '@emotion/core';
import { FLEX_COLUMN, FLEX_ROW } from '../../layout/flexBox';
import { INPUT } from '../../forms/styles/input';
import { btnStyle } from '../../forms/styles/button';
import { useFormik } from 'formik';
import { FORM_COLUMN } from '../../forms/styles/form';
import { Str } from '../../localization/translationKeys';
import LocalInput from '../../localization/LocalInput';
import LocalBtn from '../../localization/LocalBtn';
import { loginFormValidation } from '../formValidations';
import { ERROR_MSG } from '../../forms/styles/messages';
import Msg from '../../localization/Msg';
import { FIELDSET_DEFAULT } from '../../layout/fieldSetStyle';
import { COLORS } from '../../globalStyle/colors';


const styles = {
  fieldset: FIELDSET_DEFAULT,
  form:     [FLEX_COLUMN, FORM_COLUMN],
  errorMsg: [FLEX_ROW, ERROR_MSG, css`align-items: center;`],
  input:    INPUT(),
  btn:      btnStyle.primary(COLORS.GREEN),
};


type Props = {
  className?: string;
  errorMsg: Str | string;
  onLoginAttempt: (username: string, password: string) => void;
  isLoggingIn: boolean;
  initialEmail?: string;
  initialPassword?: string;
}


const LoginForm = (props: Props) => {
  const { handleSubmit, handleChange, isValid, resetForm, values } = useFormik({
    initialValues:    {
      username: props.initialEmail ?? '',
      password: props.initialPassword ?? '',
    },
    onSubmit:         (values) => {
      props.onLoginAttempt(values.username, values.password);
      resetForm();
    },
    validationSchema: loginFormValidation,
    validateOnChange: false,
  });

  return (
    <div className={props.className}>
      <fieldset disabled={props.isLoggingIn} css={styles.fieldset}>
        <form onSubmit={handleSubmit} css={styles.form}>
          {
            (!!props.errorMsg || !isValid) && (
              <div css={styles.errorMsg}>
                <Msg str={!isValid ? Str.LoginFailure : props.errorMsg} />
              </div>
            )
          }
          <LocalInput
            placeholderTranslation={Str.Email}
            name='username'
            type='text'
            value={values.username}
            css={styles.input}
            onChange={handleChange}
            autoComplete='off'
          />
          <LocalInput
            placeholderTranslation={Str.Password}
            name='password'
            type='password'
            value={values.password}
            css={styles.input}
            onChange={handleChange}
            autoComplete='off'
          />
          <LocalBtn str={Str.LogIn} type='submit' css={styles.btn} />
        </form>
      </fieldset>
    </div>
  );
};


export default LoginForm;
